type HasCreatedAt = { createdAt: string }
type HasSender = { sender: { type: string } }

function getMessagesByDateAsc<T extends HasCreatedAt>(messages: T[] = []) {
  return [...messages].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
}

function getLatestMessageFromList<T extends HasCreatedAt>(messages?: T[]) {
  if (!messages?.length) return undefined
  const asc = getMessagesByDateAsc(messages)
  return asc.at(-1)
}

function getLatestNonPatientSenderFromList<T extends HasCreatedAt & HasSender>(messages?: T[]) {
  if (!messages?.length) return undefined
  const asc = getMessagesByDateAsc(messages)
  return asc.filter((m) => m.sender.type !== 'patient').at(-1)?.sender
}

export { getLatestMessageFromList, getLatestNonPatientSenderFromList, getMessagesByDateAsc }
